import { z } from 'zod/mini';
import { listPaginationSearchSchema } from '../pagination/list-pagination-search-schema';

export const listSearchSchema = z.intersection(
    listPaginationSearchSchema,
    z.object({
        search: z.optional(z.string()),
        selected: z.optional(z.array(z.union([z.string(), z.number()]))),
        sortDir: z.optional(z.catch(z.enum(['ASC', 'DESC']), 'ASC')),
    })
);

export type TListSearchSchema = z.infer<typeof listSearchSchema>;
